module.exports = __webpack_public_path__ + "img/border_rectangle3.ef522ed4.svg";